import {
    Dataset,
    defaultTimeout,
    IModel,
    Collection,
    IViolation,
    IAttribute,
    ParameterValue,
    ModelConstants
} from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { Activity } from './activity';
import { validateEntityParameters } from 'app/shared/utils/activity-validation.util';
import { Constants } from 'app/shared/shared-constants';
import { FileTypeDataset } from '../dataset/file-type.dataset';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: ModelConstants.validationActivity,
    display: [
        format(stringResources.ModelName_ActivityTemplate, stringResources.ValidationActivityLabel),
        format(stringResources.ModelName_ActivitiesTemplate, stringResources.ValidationActivityLabel)
    ],
    referable: true
})
export class ValidationActivity extends Activity {
    public static readonly MODEL: IModel;
    public static readonly VALIDATION_TIMEOUT: IAttribute;
    public static readonly SLEEP: IAttribute;
    public static readonly MINIMUM_SIZE: IAttribute;
    public static readonly CHILD_ITEMS: IAttribute;

    @Metamodel.attribute({
        display: stringResources.Timeout,
        association: 'VALIDATION_TIMEOUT',
        constraint: {
            pattern: Constants.timeoutValidation
        }
    })
    public validationTimeout?: string = defaultTimeout;

    @Metamodel.attribute({
        display: stringResources.ValidationActivity_Sleep,
        association: 'SLEEP',
        templatable: true,
        constraint: {
            required: false,
            whole: true,
            minimum: 0
        }
    })
    public sleep?: number = 10;

    @Metamodel.attribute({
        display: stringResources.ModelName_DataSet,
        constraint: {
            required: true
        },
        reference: true,
        type: Dataset.MODEL
    })
    public dataset?: Dataset;

    @Metamodel.attribute({
        display: stringResources.ValidationActivity_MinimumSize,
        association: 'MINIMUM_SIZE',
        constraint: {
            required: false,
            whole: true,
            validator: ValidationActivity.validateMinimumSize,
            minimum: 0
        }
    })
    public minimumSize?: number;

    @Metamodel.attribute({
        display: stringResources.ChildItemsLabel,
        association: 'CHILD_ITEMS',
        constraint: {
            required: false,
            validator: ValidationActivity.validateChildItems
        }
    })
    public childItems?: boolean | undefined;

    @Metamodel.attribute({
        collection: Collection.Array,
        templatable: true,
        constraint: {
            required: false,
            validator: ValidationActivity.validateDatasetParameters
        }
    })
    public datasetParameters?: ParameterValue[] = [];

    constructor(name?: string, description?: string) {
        super(name, description);
        this.activityType = 'ControlActivity';
    }

    private static validateDatasetParameters(activity: ValidationActivity): IViolation[] | undefined {
        if (activity != null && activity.dataset != null) {
            return validateEntityParameters(activity.dataset, activity.datasetParameters || [], activity);
        }
        return undefined;
    }

    private static validateChildItems(activity: ValidationActivity): IViolation[] | undefined {
        if (activity && activity.dataset && (activity.dataset instanceof FileTypeDataset)) {
            const dataset = activity.dataset;
            if (activity.childItems && (!!dataset.fileName || !!FileTypeDataset.FILE_NAME.templateValue(dataset))) {
                return [
                    {
                        message: () => stringResources.Validation_ChildItemsFolderError
                    }
                ];
            }
        }
        return undefined;
    }

    private static validateMinimumSize(activity: ValidationActivity): IViolation[] | undefined {
        if (activity && activity.dataset && (activity.dataset instanceof FileTypeDataset)) {
            const dataset = activity.dataset;
            if (activity.minimumSize && (!dataset.fileName && !FileTypeDataset.FILE_NAME.templateValue(dataset))) {
                return [
                    {
                        message: () => stringResources.Validation_MinimumsizeFileError
                    }
                ];
            }
        }
        return undefined;
    }
}
